import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { Announcement } from "@/features/Announcements/Announcement";
import { AnnouncementsPageQuery } from "@/features/Announcements/AnnouncementsPageQuery";
import { MarkReadButton } from "@/features/Announcements/MarkReadButton";
import { useTranslation } from "@/i18n/client";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/announcements",
)({
  component: Page,
});

function Page() {
  const { t } = useTranslation("Announcements");
  const { data } = useSuspenseQuery(AnnouncementsPageQuery);
  const firstAnnouncement = data.announcements.nodes[0];

  return (
    <>
      <PageTitle title="announcements" />
      <Section variant="header">
        <SectionHeader
          header={t("title")}
          buttons={
            firstAnnouncement && (
              <MarkReadButton announcement={firstAnnouncement} />
            )
          }
        />
      </Section>

      <Section variant="content">
        {data.announcements.nodes.length === 0 && (
          <div className="">{t("noAnnouncements")}</div>
        )}
        <div className="flex flex-col gap-4">
          {data.announcements.nodes.map((announcement) => (
            <Announcement key={announcement.id} announcement={announcement} />
          ))}
        </div>
      </Section>
    </>
  );
}
